import React from "react";
import { CompanySettings } from "../../Models/CompanySettings";
import { ToggleSetting } from "../../../Layout";
import { CompanySettingName } from "../../Constants/CompanySettingName";

type Props = {
  settings: CompanySettings;
  onSetSetting: (key: string, value: string, action: () => void) => void;
};

type State = {
  showAsAnonymous: boolean;
};

export class PrivacySettings extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      showAsAnonymous: this.props.settings.showAsAnonymous
    };
  }

  toggleShowAsAnonymous = () => {
    this.props.onSetSetting(
      CompanySettingName.ShowAsAnonymous,
      String(!this.state.showAsAnonymous),
      () => {
        this.setState(prevState => ({
          showAsAnonymous: !prevState.showAsAnonymous
        }));
      }
    );
  };

  render() {
    return (
      <div>
        <ToggleSetting
          settingName="Hide company name from people in other companies"
          settingDescription='This will display your company name as "Anonymous" to anyone not in your company'
          onToggle={this.toggleShowAsAnonymous}
          state={this.state.showAsAnonymous}
          labeled
        />
      </div>
    );
  }
}
